export default __webpack_public_path__ + "static/media/teacher.00ffbd8e.svg";